import { ITag } from '../../types/tags';

export function stringifyTags(tags: ITag[]) {
  return tags.map(tag => tag.name).join(', ');
}
